import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { api } from '../api';
import ImageCard from '../components/ImageCard';
import '../components/ImageCard.css';

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = (params.get('q') || '').toLowerCase();
  const [hits, setHits] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      setLoading(true);
      const cats = await api('/api/categories');
      const results = [];
      for (const c of cats) {
        const rel = new URLSearchParams(c.path.split('?')[1]).get('rel');
        const r = await api(`/api/category?rel=${encodeURIComponent(rel)}`);
        if (r.type === 'dirs') {
          for (const sd of r.items) {
            const rel2 = new URLSearchParams(sd.path.split('?')[1]).get('rel');
            const r2 = await api(`/api/category?rel=${encodeURIComponent(rel2)}`);
            if (r2.type === 'images') {
              r2.items.forEach(it => {
                if (it.name.toLowerCase().includes(q)) results.push({ rel: rel2, ...it });
              });
            }
          }
        } else if (r.type === 'images') {
          r.items.forEach(it => {
            if (it.name.toLowerCase().includes(q)) results.push({ rel, ...it });
          });
        }
      }
      setHits(results);
      setLoading(false);
    })();
  }, [q]);
  if (loading) return <div style={{padding:16}}>Searching…</div>;
  return (
    <div style={{padding:16}}>
      <h3>Search results for: {q}</h3>
      {hits.length === 0 ? (
        <div>No results</div>
      ) : (
        <div className="image-grid">
          {hits.map((h, idx) => (
            <ImageCard
              key={`${h.rel}-${h.name}-${idx}`}
              name={h.name}
              imageUrl={h.imageUrl}
              viewRel={h.viewRel}
              downloadUrl={h.downloadUrl}
            />
          ))}
        </div>
      )}
    </div>
  );
}

